import { useEffect, useState } from 'react';

const useOnTouch = (
    refWrapper,
    refContainer,
    isCenter = false,
    { translateX = 0, transition = 0.5 } = {}
) => {
    const [inlineStyles, setInlineStyles] = useState({ translateX, transition });
    const [onTouch, setOnTouch] = useState({});

    const handleOnTouchStart = (x, y) => setOnTouch({ x, y });

    const handleOnTouchEnd = (x, y) => {
        const deltaX = onTouch.x - x;
        const deltaY = Math.abs(onTouch.y - y);

        if (Math.abs(deltaX) > 3 * deltaY) {
            const scroll = refContainer.current.scrollWidth - refWrapper.current.offsetWidth;

            if (deltaX < 0) {
                const { translateX } = inlineStyles;
                setInlineStyles({
                    translateX: Math.abs(translateX) - Math.abs(deltaX) > 0 ? (translateX - deltaX) : 0,
                    transition,
                });
            }

            if (deltaX > 0) {
                const { translateX } = inlineStyles;
                setInlineStyles({
                    translateX: Math.abs(translateX) + deltaX < scroll ? (translateX - deltaX) : -scroll,
                    transition,
                });
            }
        }

        setOnTouch({});
    };

    const handleResize = (transition = transition) => {
        if (refContainer.current && refWrapper.current) {
            const scroll = refContainer.current.scrollWidth - refWrapper.current.offsetWidth;

            if (scroll !== 0 && isCenter) {
                setInlineStyles({
                    translateX: -Math.trunc(scroll / 2),
                    transition,
                });
            } else {
                setInlineStyles({
                    translateX: 0,
                    transition,
                });
            }
        }
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        }
    }, []);

    return {
        handleOnTouchStart,
        handleOnTouchEnd,
        inlineStyles,
        handleResize,
    }
};

export default useOnTouch;
